// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  title: 'Cellar Shop',
  mobileTitle: 'Cellar Shop',
  searchConsoleUrl: '',
  canonicalBaseAddress: '',
  enablePwaMode: false,
  enableNgxsDevMode: true,
  inMemory: false,
  inMemoryDelay: 2000,
  inferiorBrowsers: ['ie', 'edge', 'safari'],
  routeOnLogout: {
    enabled: false,
    url: ['/login']
  },
  allowLoginDialog: false,
  defaultToAdUser: true,
  globalHttpActivitySpinner: true,
  globalHttpErrorSnackbar: true,
  globalHttpErrorSnackbarDuration: 5000,
  blockUiOnSignalrDisconnect: false,
  websiteApiBaseAddress: 'https://sgconvenience-api.sgconvenience.co.za/api/',
  webApiBaseAddress: 'https://cellashopqa.supergrp.net/WebApi',//'http://localhost:5000',n
  // webApiBaseAddress: 'http://localhost:5000',
  signalRBaseAddress: 'https://hyper.supergrp.net/webapi/hub',
  reportConfig: {
    reportApiBaseAddress: 'https://www.sg-api.co.za/SSRSApi/api/',
    clientId: '6168A902-5B3B-4F3B-8C42-7E172B02419D',
    userReference: 'sub'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
